import type { StatusRowValue } from '@components/SupplyManagement/SupplyDirectory/types'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { IconCircleCheckFilled, IconCoinOff } from '@tabler/icons-react'
import { Popover } from 'antd'
import React, { useState } from 'react'

import { UpcomingOutagesPopover } from '../../UpcomingOutagesPopover'

type StatusRendererProps = {
  value: StatusRowValue
  openEditOutageDrawer: (outage: Gravitate.SupplyOutage) => void
  cancelOutage: (outageId: string) => void
}

export function StatusRenderer({ value, openEditOutageDrawer, cancelOutage }: StatusRendererProps) {
  const [visible, setVisible] = useState(false)

  return (
    <Popover
      content={
        <UpcomingOutagesPopover
          rowValue={value}
          closeOutagePopover={() => setVisible(false)}
          openEditOutageDrawer={openEditOutageDrawer}
          cancelOutage={cancelOutage}
        />
      }
      trigger='click'
      open={visible}
      onOpenChange={setVisible}
      placement='right'
      styles={{
        body: { width: '490px' },
      }}
    >
      <div
        role='button'
        aria-disabled={!value.outages?.length}
        tabIndex={0}
        style={{ cursor: 'pointer', display: 'flex' }}
      >
        <Horizontal>
          {value.enabled ? (
            <IconCircleCheckFilled color='var(--theme-success)' size={18} />
          ) : (
            <IconCoinOff color='var(--theme-error)' size={18} />
          )}
        </Horizontal>
        <Texto weight={700} className='ml-2'>
          {value.enabled ? 'Enabled' : 'Disabled'}
        </Texto>
      </div>
    </Popover>
  )
}
